import { render } from "./PreviewLiveSwitch.vue?vue&type=template&id=737bb0c3"
import script from "./PreviewLiveSwitch.vue?vue&type=script&lang=js"
export * from "./PreviewLiveSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__